import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["siteSelect"]
  static values = { isEdit: Boolean, selectedNumberId: String }

  connect() {
    if (!this.isEditValue) {
      this.loadContactDetails({ target: this.siteSelectTarget })
    }

    this.siteSelectTarget.addEventListener("change", this.loadContactDetails.bind(this))
  }

  async loadContactDetails(event) {
    const siteId = event.target.value
    const selectedPhoneNumber = this.element.dataset.selectedNumberId
    // Absent when the tenant's form layout hides the phone number block.
    const dropdown = document.getElementById("task_customer_phone_number_id")
    if (!siteId || !dropdown) {
      return
    }

    try {
      const response = await fetch(`/tasks/customer_phone_numbers/${siteId}`)
      const phoneNumbers = await response.json()

      dropdown.innerHTML = '<option value=""></option>'
      if (phoneNumbers && phoneNumbers.length > 0) {
        phoneNumbers.forEach((phone) => {
          const option = document.createElement("option")
          option.value = phone.id
          option.textContent = phone.label

          // Set the selected option if it matches the selectedPhoneNumberId
          if (phone.id === parseInt(selectedPhoneNumber)) {
            option.selected = true
          }

          dropdown.appendChild(option)
        })
      }
    } catch (error) {
      console.error("Error loading phone numbers:", error)
    }
  }
}
